import { env } from '../../../env';
import APIService from '../../../services/api.service';
import { DropDownData } from '../../../types/dropdown.api';
import { QUERY_CONFIG } from '../../../shared/utils/cache-config.utils';
import { ToastService } from '../../../services/toast.service';
import create from 'zustand';
import { useEffect } from 'react';
import { useMsal } from '@azure/msal-react';
import { useQuery } from 'react-query';

interface DataState {
   data: DropDownData;
   isLoading: boolean;
}

export const useDropDownDataState = create<DataState>(() => ({
   data: {} as DropDownData,
   isLoading: false,
}));

export const useDropDownData = () => {
   const { instance } = useMsal();

   const fetchAndSaveNewTokenToStorage = async () => {
      const accessTokenRequest = {
         scopes: [env.REACT_APP_AUTH_BACKEND_API_SCOPE || ''],
         account: instance.getAllAccounts()[0],
      };

      const result = await instance.acquireTokenSilent(accessTokenRequest).catch((e) => {
         instance.acquireTokenRedirect({ scopes: ['User.Read'] });
         return e;
      });

      localStorage.setItem('accessToken', result.accessToken);
   };

   const fetchDropDownData = async () => {
      await fetchAndSaveNewTokenToStorage();
      return APIService.getDropDownData();
   };

   const { status, data: response, error } = useQuery('dropDownData', fetchDropDownData, QUERY_CONFIG);

   useEffect(() => {
      useDropDownDataState.setState({ isLoading: status === 'loading' });
   }, [status]);

   useEffect(() => {
      switch (status) {
         case 'error':
            ToastService.error(String(error));
            break;
         case 'success':
            if (response) {
               useDropDownDataState.setState({ data: response });
            }
            break;
      }
   }, [status, response, error]);
};
